import theme from '@styles/theme';
export default {
  infoCardContainer: (bg?: string, color?: string) => ({
    width: '100%',
    height: ['auto'],
    display: 'flex',
    flexWrap: ['wrap', 'wrap', 'nowrap'],
    alignItems: 'stretch',
    bg: bg || theme.rawColors.beige300,
    color: color || theme.rawColors.darkGrey700
  }),
  infoCardImage: {
    position: 'relative',
    width: ['100%', '100%', 'calc(50% - 2px)'],
    height: ['100vw', '100vw', 'auto', '100%'],
    pb: ['50%', '50%', 'calc(50% - 2px)', 'calc(50% - 2px)', 'calc(50% - 3px)'],
    '& > div': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  },
  infoCardDescription: {
    width: ['100%', '100%', 'calc(50% + 2px)'],
    p: [40, 40, 64, '16px 24px', '16px 24px', '16px 48px', '16px 80px'],
    display: 'flex',
    alignItems: 'center',
    'p.description': {
      mb: 24,
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: ['unset', 'unset', '10', '3', '3', '5', '6', 'unset'],
      textOverflow: 'ellipsis'
    }
  }
};